module.exports = __webpack_public_path__ + "static/media/identificacion.aa6d07af.svg";